
import { Options, Vue } from "vue-property-decorator";
import LoadingSpinner from "../loading-spinner/index.vue";
import ModalBox from "../modal-box/index.vue";

@Options({
  props: {
  },
  components: {
    ModalBox,
    LoadingSpinner,
  }
})
export default class KitchensinkModal extends Vue {
  showKitchensinkModal!: boolean;

  private canSubmit = false;

  private showFullScreenFileViewer = false;
  private showStepper = false;
  private halfScreen = false;
  private show = false;
  private isLoadingData = false;

  private mandatoryCheck() {
    // put some logic here
    this.canSubmit = true;
  }

  private mockData = {
    name: '',
    desc: ''
  }

  mounted(): void {
    this.show = this.showKitchensinkModal;
  }

  private cancelClicked() {
    // if (this.isFormDirty && !this.isReadonly) {
    //   this.showCancelAlert = true;
    // } else {
    this.closeModal();
  }

  // private yesCancel() {
  //   this.closeModal();
  // }

  private closeModal() {
    this.$emit('closeModal');
  }

  private submit() {
    this.isLoadingData = true;
    setTimeout(() => {
      this.isLoadingData = false;
      this.closeModal();
    }, 1000)

  }


}

